import config from 'config';
import { useSelector } from 'react-redux';
import { getLocalizedPath } from '../utils/urlHelpers';
import { getActiveLocale } from '@wsc/redux_stores/localizeReducer';
import { useNavigate } from 'react-router';

const useLocalizedNavigation = () => {
	const navigate = useNavigate();
	const activeLocale = useSelector(getActiveLocale);

	const showLocaleInClientLink = useSelector(
		(state) => state?.storeData?.localization?.show_locale_on_client_link === true,
	);

	// Note:1
	// const scenes = useSelector(getSceneIdToNamesMap);
	// const activeSceneID = useSelector(selectActiveScene);

	return {
		navigate: (sceneName) => {
			// if (scenes?.[activeSceneID] === sceneName) return; // Note:1
			const pathToGo =
				config.ENV !== 'client' || showLocaleInClientLink
					? getLocalizedPath(activeLocale, sceneName)
					: getLocalizedPath('', sceneName);
			navigate(pathToGo);
		},
	};
};

/**
 * Notes:
 * 1. This was put because switching scenes was causing a jump in UMG. But it's not an issue anymore so commenting it out as this was causing black screen in some other stores.
 */
export default useLocalizedNavigation;
